import React from "react";
import { Routes, Route } from "react-router-dom";
import Contacts from "../Pages/Contacts";
import Home from "../Pages/Home";
import Projects from "../Pages/Projects";
import Services from "../Pages/Services";
import NotFound from "../Pages/NotFound";
import About from "../Pages/About";
import PrivacyCC from "../Pages/PrivacyCC";
import PrivacyEUC from "../Pages/PrivacyEUC";
import Portfolio from "../Pages/Portfolio";
import PrivacyCB from "../Pages/PrivacyCB";
import PrivacyMB from "../Pages/PrivacyMB";
import DeleteAccountCB from "../Pages/DeleteAccountCB";
import PrivacyME from "../Pages/PrivacyME";
import PrivacySME from "../Pages/PrivacySME";
import TermsSME from "../Pages/TermsSME";
import PrivacySB from "../Pages/PrivacySB";
import PrivacyMM from "../Pages/PrivacyMM";
import PrivacyMS from "../Pages/PrivacyMS";

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/contacts" element={<Contacts />} />
      <Route path="/privacy-cc" element={<PrivacyCC />} />
      <Route path="/privacy-euc" element={<PrivacyEUC />} />
      <Route path="/privacy-cb" element={<PrivacyCB />} />
      <Route path="/privacy-mb" element={<PrivacyMB />} />
      <Route path="/privacy-me" element={<PrivacyME />} />
      <Route path="/privacy-sme" element={<PrivacySME />} />
      <Route path="/terms-sme" element={<TermsSME />} />
      <Route path="/privacy-sb" element={<PrivacySB />} />
      <Route path="/privacy-mm" element={<PrivacyMM />} />
      <Route path="/privacy-ms" element={<PrivacyMS />} />
      <Route path="/delete-account-cb" element={<DeleteAccountCB />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
}
